import {IEntityDocumentSummary} from './entity-document-summary';
import {DateTimeWithZone} from '../common/date-time-with-zone.class';
import {ICompanyDocumentSummary} from './company-document-summary.interface';
import {EntityDocumentSummary} from './entity-document-summary.class';
import {IObservation} from './observation.interface';

export class CompanyDocumentSummary extends EntityDocumentSummary implements ICompanyDocumentSummary {
  constructor(iCompanyDocumentSummary?: ICompanyDocumentSummary) {
    super(iCompanyDocumentSummary as IEntityDocumentSummary);
    this.companyId = iCompanyDocumentSummary?.companyId || '00000000-0000-0000-0000-000000000000';
  }
  companyId: string;

}
